// import React, { useState } from "react";
// import Header from "../Header/Header";
// import { useNavigate } from "react-router-dom";
// import TopRatedProducts from "./Components/TopRatedProducts";
// import DealsPage from "./Components/DealsPage";
// import Footer from "../../Components/Footer/Footer";

// const Home = () => {
// 	const [isExpanded, setIsExpanded] = useState(false);
// 	const navigate = useNavigate();

// 	const handleToggle = () => {
// 		setIsExpanded(!isExpanded);
// 	};

// 	const handleShopNowClick = () => {
// 		navigate("/payment-gateway");
// 	};

// 	const handleAddToCart = (product) => {
// 		// addToCart(product);
// 		console.log("Item added to cart", product);
// 	};

// 	const handleSeeAll = () => {
// 		navigate("/see-all");
// 	};

// 	const handleNavigation = (path) => {
// 		navigate(path);
// 	};

// 	const products = [
// 		{
// 			id: 1,
// 			name: "Perfect Blazer men for PartyWear",
// 			price: 250,
// 			discountPrice: 300,
// 			img: "istockphoto-1092378606-612x612.jpg",
// 		},
// 		{
// 			id: 2,
// 			name: "Long Suit for Girls for PartyWear",
// 			price: 250,
// 			discountPrice: 300,
// 			img: "istockphoto-526719098-612x612.jpg",
// 		},
// 		{
// 			id: 3,
// 			name: "Shoes for PartyWear",
// 			price: 250,
// 			discountPrice: 300,
// 			img: "istockphoto-1308274455-612x612.jpg",
// 		},
// 		{
// 			id: 4,
// 			name: " Girls bag for PartyWear",
// 			price: 250,
// 			discountPrice: 300,
// 			img: "istockphoto-1363767151-612x612.jpg",
// 		},
// 		{
// 			id: 3,
// 			name: "Polo T shirt for men",
// 			price: 250,
// 			discountPrice: 300,
// 			img: "istockphoto-1416433020-640x640.jpg",
// 		},
// 	];

// 	return (
// 		<div className="font-sans">
// 			<Header />
// 			{/* Hero Section with reduced gap */}
// 			<div className="relative p-6 md:p-12 lg:p-20 bg-[#F9F6F1] border-b border-stone-200 flex flex-col lg:flex-row justify-between items-center min-h-[80vh] overflow-hidden">

// 				{/* Subtle Wood Texture Overlay */}
// 				<div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]"></div>

// 				{/* Text Content Area */}
// 				<div className="relative z-10 flex flex-col justify-center text-center lg:text-left w-full lg:w-1/2 animate-in fade-in slide-in-from-left-8 duration-1000">

// 					{/* Floating Badge */}
// 					<div className="inline-flex items-center self-center lg:self-start bg-yellow-950/5 border border-yellow-950/10 text-yellow-950 px-4 py-2 rounded-full mb-10">
// 						<span className="w-2 h-2 bg-yellow-700 rounded-full animate-pulse mr-3"></span>
// 						<p className="text-xs lg:text-sm font-bold tracking-[0.2em] uppercase">Premium Craftsmanship</p>
// 					</div>

// 					{/* Main Heading */}
// 					<h1 className="text-4xl md:text-5xl lg:text-7xl font-serif text-stone-900 leading-[1.1] mb-8">
// 						Transform Your Space <br />
// 						<span className="italic font-light text-yellow-900 text-3xl md:text-4xl lg:text-6xl block mt-2">
// 							Into A Masterpiece
// 						</span>
// 					</h1>

// 					{/* Description */}
// 					<p className="text-base lg:text-xl text-stone-600 mb-16 max-w-xl leading-relaxed font-light">
// 						Discover our exclusive collection of handcrafted furniture that seamlessly blends contemporary aesthetics
// 						with functional design excellence. Each piece is a testament to timeless quality.
// 					</p>

// 					{/* Feature List - Now serves as the primary focal point below text */}
// 					<div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-10 border-t border-stone-300/60">
// 						<div className="flex flex-col items-center lg:items-start gap-2">
// 							<span className="text-yellow-800 font-serif italic text-2xl">01</span>
// 							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">Free Shipping</span>
// 						</div>
// 						<div className="flex flex-col items-center lg:items-start gap-2">
// 							<span className="text-yellow-800 font-serif italic text-2xl">02</span>
// 							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">5-Year Warranty</span>
// 						</div>
// 						<div className="flex flex-col items-center lg:items-start gap-2">
// 							<span className="text-yellow-800 font-serif italic text-2xl">03</span>
// 							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">Custom Design</span>
// 						</div>
// 					</div>
// 				</div>

// 				{/* Image Area */}
// 				<div className="relative mt-16 lg:mt-0 w-full lg:w-1/2 flex justify-center lg:justify-end animate-in fade-in zoom-in-95 duration-1000">
// 					{/* Decorative background element for the image */}
// 					<div className="absolute -bottom-10 -right-10 w-64 h-64 bg-yellow-900/5 rounded-full blur-3xl"></div>

// 					<div className="relative group">
// 						<img
// 							src="assets/greenchair.png"
// 							alt="Modern Luxury Sofa Set"
// 							className="relative z-10 w-full max-w-lg lg:max-w-xl h-auto object-cover rounded-tr-[80px] rounded-bl-[80px] shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]"
// 						/>
// 						{/* The "Frame" effect */}
// 						<div className="absolute -top-4 -left-4 w-full h-full border-2 border-yellow-950/10 rounded-tr-[80px] rounded-bl-[80px] z-0 transition-all group-hover:top-0 group-hover:left-0"></div>
// 					</div>
// 				</div>
// 			</div>

// 			{/* <CategorySlider /> */}
// 			<TopRatedProducts />

// 			<DealsPage />

// 			<Footer />
// 		</div>
// 	);
// };

// export default Home;
















import React from "react";
import Header from "../Header/Header";
import TopRatedProducts from "./Components/TopRatedProducts";
import DealsPage from "./Components/DealsPage";
import Footer from "../../Components/Footer/Footer";
import { Truck, ShieldCheck, Ruler, ArrowRight } from "lucide-react";

const scrollToId = (id) =>
	document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const FEATURES = [
	{ icon: Truck, label: "Free Shipping" },
	{ icon: ShieldCheck, label: "5-Year Warranty" },
	{ icon: Ruler, label: "Custom Design" },
];

const Home = () => {
	return (
		<div className="font-sans bg-white">
			<Header />

			{/* ================= Hero ================= */}
			{/* <section className="relative overflow-hidden bg-[#FBF7F0] border-b border-yellow-900/10">
				<div className="mx-auto max-w-[1320px] px-4 py-10 md:py-16 lg:py-20 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

					<div className="text-center lg:text-left">
						<span className="inline-flex items-center gap-2 rounded-full border border-yellow-800/20 bg-yellow-800/5 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-yellow-900">
							<span className="h-1.5 w-1.5 rounded-full bg-yellow-800" />
							Premium Craftsmanship
						</span>

						<h1 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-gray-900">
							Transform your space
							<span className="block text-yellow-800">into a masterpiece</span>
						</h1>

						<p className="mt-4 mx-auto lg:mx-0 max-w-xl text-sm sm:text-base leading-relaxed text-gray-600">
							Discover our exclusive collection of handcrafted furniture that blends contemporary
							aesthetics with functional design. Each piece is a testament to timeless quality.
						</p>

						<div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-3">
							<button
								type="button"
								onClick={() => scrollToId("categories")}
								className="inline-flex items-center gap-2 rounded-md bg-yellow-800 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-yellow-900 transition-colors"
							>
								Shop Now <ArrowRight size={16} />
							</button>
							<button
								type="button"
								onClick={() => scrollToId("favorites")}
								className="inline-flex items-center rounded-md border border-yellow-800 px-6 py-3 text-sm font-semibold text-yellow-800 hover:bg-yellow-50 transition-colors"
							>
								Customer Favorites
							</button>
						</div>

						<div className="mt-9 grid grid-cols-3 gap-3 border-t border-yellow-900/10 pt-6">
							{FEATURES.map(({ icon: Icon, label }) => (
								<div key={label} className="flex flex-col lg:flex-row items-center gap-2 lg:gap-3">
									<span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-yellow-800 shadow-sm border border-gray-200">
										<Icon size={18} />
									</span>
									<span className="text-xs sm:text-sm font-medium text-gray-700 text-center lg:text-left">
										{label}
									</span>
								</div>
							))}
						</div>
					</div>

					<div className="relative flex justify-center lg:justify-end">
						<div className="absolute -bottom-8 -right-4 h-64 w-64 rounded-full bg-yellow-800/10 blur-3xl" />
						<div className="relative">
							<div className="absolute -top-3 -left-3 h-full w-full rounded-2xl border-2 border-yellow-800/15" />
							<img
								src="assets/greenchair.png"
								alt="Modern luxury sofa set"
								className="relative z-10 w-full max-w-md lg:max-w-lg h-auto rounded-2xl object-cover shadow-xl"
							/>
						</div>
					</div>
				</div>
			</section> */}

			<div className="relative p-6 md:p-12 lg:p-20 bg-[#F9F6F1] border-b border-stone-200 flex flex-col lg:flex-row justify-between items-center min-h-[80vh] overflow-hidden">

				{/* Subtle Wood Texture Overlay */}
				<div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]"></div>

				{/* Text Content Area */}
				<div className="relative z-10 flex flex-col justify-center text-center lg:text-left w-full lg:w-1/2 animate-in fade-in slide-in-from-left-8 duration-1000">

					{/* Floating Badge */}
					<div className="inline-flex items-center self-center lg:self-start bg-yellow-950/5 border border-yellow-950/10 text-yellow-950 px-4 py-2 rounded-full mb-10">
						<span className="w-2 h-2 bg-yellow-700 rounded-full animate-pulse mr-3"></span>
						<p className="text-xs lg:text-sm font-bold tracking-[0.2em] uppercase">Premium Craftsmanship</p>
					</div>
					{/* Main Heading */}
					<h1 className="text-4xl md:text-5xl lg:text-7xl font-serif text-stone-900 leading-[1.1] mb-8">
						Transform Your Space <br />
						<span className="italic font-light text-yellow-900 text-3xl md:text-4xl lg:text-6xl block mt-2">
							Into A Masterpiece
						</span>
					</h1>

					{/* Description */}
					<p className="text-base lg:text-xl text-stone-600 mb-16 max-w-xl leading-relaxed font-light">
						Discover our exclusive collection of handcrafted furniture that seamlessly blends contemporary aesthetics
						with functional design excellence. Each piece is a testament to timeless quality.
					</p>

					{/* Feature List - Now serves as the primary focal point below text */}
					<div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-10 border-t border-stone-300/60">
						<div className="flex flex-col items-center lg:items-start gap-2">
							<span className="text-yellow-800 font-serif italic text-2xl">01</span>
							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">Free Shipping</span>
						</div>
						<div className="flex flex-col items-center lg:items-start gap-2">
							<span className="text-yellow-800 font-serif italic text-2xl">02</span>
							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">5-Year Warranty</span>
						</div>
						<div className="flex flex-col items-center lg:items-start gap-2">
							<span className="text-yellow-800 font-serif italic text-2xl">03</span>
							<span className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-bold">Custom Design</span>
						</div>
					</div>
				</div>

				{/* Image Area */}
				<div className="relative mt-16 lg:mt-0 w-full lg:w-1/2 flex justify-center lg:justify-end animate-in fade-in zoom-in-95 duration-1000">
					{/* Decorative background element for the image */}
					<div className="absolute -bottom-10 -right-10 w-64 h-64 bg-yellow-900/5 rounded-full blur-3xl"></div>

					<div className="relative group">
						<img
							src="assets/greenchair.png"
							alt="Modern Luxury Sofa Set"
							className="relative z-10 w-full max-w-lg lg:max-w-xl h-auto object-cover rounded-tr-[80px] rounded-bl-[80px] shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]"
						/>
						{/* The "Frame" effect */}
						<div className="absolute -top-4 -left-4 w-full h-full border-2 border-yellow-950/10 rounded-tr-[80px] rounded-bl-[80px] z-0 transition-all group-hover:top-0 group-hover:left-0"></div>
					</div>
				</div>
			</div>



			<TopRatedProducts />
			<DealsPage />
			<Footer />
		</div>
	);
};

export default Home;